// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountGetTasksDefaultResponse {
    static getAttributeTypeMap() {
        return AccountGetTasksDefaultResponse.attributeTypeMap;
    }
}
AccountGetTasksDefaultResponse.discriminator = undefined;
AccountGetTasksDefaultResponse.additionalProperties = false;
AccountGetTasksDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<NoteTaskModel>"
    },
];
//# sourceMappingURL=accountGetTasksDefaultResponse.js.map